/*
 * Project: bellcloud
 * File: packages/types/device/lite/protocol_cmds.ts
 * Author: SWAN
 * Created: 2025-07-08 11:31:36
 * Description:
 */

export enum ClassID {
  INFORMATION = 0x01,
  MONITORING = 0x02,
  CONFIGURATION = 0x03,
  CALIBRATION = 0x04,
  FILE_TRANSFER = 0x10,
  MAINTENANCE = 0x11,
  FACTORY = 0xf0,
  DEVELOPMENT = 0xf1,
}
